import { Button, Typography, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";

import React from "react";
import { EditOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

export function AccueilButton() {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        position: "absolute",
        top: 25,
        right: 25,
      }}
    >
      <Button
        type="primary"
        size="large"
        icon={<HomeOutlined />}
        onClick={() => navigate("/")}
        style={{
          borderRadius: "50px",
          padding: "0 22px",
          background: "linear-gradient(90deg, #1677ff, #4096ff)",
          boxShadow: "0 4px 15px rgba(22, 119, 255, 0.4)",
          fontWeight: 600,
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        Accueil
      </Button>
    </motion.div>
  );
}

export default function Home() {
  const navigate = useNavigate();

  const buttons = [
    { label: "CAP - Jour", path: "/cap/tetra_bus" },
    { label: "CAP - Noc", path: "/cap_noc/tetra_bus" },
    { label: "KEOLIS", path: "/keolis/tetra_bus" },
    { label: "KEOLIS - Noc", path: "/keolis_noc/tetra_bus" },
    { label: "CDS", path: "/all/tetra_bus" },
    // { label: "ADMIN", path: "/all/tetra_bus" },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #dbeafe 0%, #eff6ff 40%, #ffffff 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >

      {/* Dégradé décoratif animé */}
      <motion.div
        animate={{ y: [0, 20, 0] }}
        transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
        style={{
          position: "absolute",
          top: "-100px",
          left: "-100px",
          width: "300px",
          height: "300px",
          background: "radial-gradient(circle at center, #1677ff55, transparent)",
          borderRadius: "50%",
          filter: "blur(60px)",
          zIndex: 0,
        }}
      />

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        style={{ zIndex: 2 }}
      >
        <Card
          bordered={false}
          style={{
            width: 440,
            textAlign: "center",
            borderRadius: "18px",
            padding: "45px 30px",
            backdropFilter: "blur(12px)",
            background:
              "rgba(255, 255, 255, 0.75) linear-gradient(145deg, rgba(255,255,255,0.6), rgba(240,240,255,0.8))",
            boxShadow: "0 10px 35px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Title level={3} style={{ color: "#1f2937", marginBottom: 8 }}>
            Bienvenu(e) sur l’outil de validation
          </Title>
          <Title
            level={2}
            style={{
              color: "#1677ff",
              fontWeight: "800",
              marginBottom: 35,
              letterSpacing: "1px",
            }}
          >
            TETRA / SAE
          </Title>

          <Text strong style={{ fontSize: 17, color: "#334155" }}>
            Je suis un utilisateur :
          </Text>

          <div
            style={{
              marginTop: 25,
              display: "flex",
              flexDirection: "column",
              gap: 14,
            }}
          >
            {buttons.map((btn, i) => (
              <motion.div
                key={btn.path}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 + i * 0.1 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
              >
                <Button
                  block
                  size="large"
                  onClick={() => navigate(btn.path)}
                  style={{
                    height: 52,
                    borderRadius: "10px",
                    fontWeight: "600",
                    fontSize: "16px",
                    border: "none",
                    color: "#fff",
                    background:
                      "linear-gradient(90deg, #1677ff, #4096ff, #60a5fa)",
                    boxShadow: "0 4px 10px rgba(22,119,255,0.3)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {btn.label}
                </Button>
              </motion.div>
            ))}
          </div>
        </Card>
      </motion.div>

    </div>
  );
}
